import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    token: localStorage.getItem('token') || ''
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
    },
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    CLEAR_AUTH(state) {
      state.user = null
      state.token = ''
      localStorage.removeItem('token')
      sessionStorage.removeItem('profilePromptShown')
      sessionStorage.removeItem('profileComplete')
      sessionStorage.removeItem('profileChecked')
    }
  },
  actions: {
    login({ commit }, { token, user }) {
      commit('SET_TOKEN', token)
      commit('SET_USER', user)
    },
    async logout({ commit, state }) {
      const token = state.token || localStorage.getItem('token')
      if (token) {
        try {
          await axios.post('/api/auth/logout', {}, {
            headers: { Authorization: `Bearer ${token}` }
          })
        } catch (e) { /* 忽略网络错误，仍清除本地 */ }
      }
      commit('CLEAR_AUTH')
    }
  }
})


